var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dl",
    { staticClass: "clearfix bg-blue-box p15 mt15" },
    [
      _c(
        "job-preview-right-column",
        _vm._g(
          {
            attrs: {
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "comment-class": "sub",
              "comment-highlights": _vm.commentHighlights,
              "text-count-class": "sub",
              "text-counts": _vm.textCounts,
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c("dt", { class: _vm.titleClass }, [
        _vm._v("\n    【" + _vm._s(_vm.title) + "】\n  "),
      ]),
      _vm._v(" "),
      _c("dd", {
        staticClass: "pega-pre-wrap",
        attrs: { id: _vm.targetId },
        domProps: { textContent: _vm._s(_vm.value) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }